const ERROR_BANNER_IDS = {
  QUOTE_ANNOUNCEMENT_BANNER: 'QUOTE_ANNOUNCEMENT_BANNER',
};

export default ERROR_BANNER_IDS;
